import * as _ from 'lodash';

import { DiacriticResolver } from '../shared';

export class DiacriticSort {
  private static readonly startsWithSpecialCharOrNumber =
    /^[0-9\s~`!@#$%^&*()_+={[}\]|\\:;"'<,>.?/-]/;
  private static readonly specialCharCheck =
    /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  /**
   * Use this method to get sorted array as per description in jira ticket (CTA-23312)
   * @date 10/27/2023 - 3:03:42 PM
   *
   * @public
   * @static
   * @template T is object type
   * @param {Array<T>} values array of object
   * @param {string} key use to sort according to object key/attribute
   * @returns {Array<T>} return sorted array
   */
  public static sort<T>(values: Array<T>, key: string): Array<T> {
    /*creating deep copy will not change original array */
    values = _.cloneDeep(values);
    values = this.replaceWithAlphabets<T>(values, key);
    /*Filter out objects where key starts with a number or special char or if its empty*/
    const withSpecialChar = values.filter(
      (obj: T) =>
        this.startsWithSpecialCharOrNumber.test(obj[key]) || obj[key] === ''
    );

    values = values
      .filter((obj: T) => !withSpecialChar.includes(obj))
      .sort((current: T, next: T) =>
        this.sortLocaleCompare(current, next, key)
      );

    return [...values, ...withSpecialChar];
  }

  private static sortLocaleCompare<T>(current: T, next: T, key: string) {
    return current[key].localeCompare(next[key]);
  }

  private static replaceWithAlphabets<T>(
    values: Array<T>,
    key: string
  ): Array<T> {
    values.forEach((_value: T, index: number) => {
      let name = values[index][key];
      DiacriticResolver.forEach(
        (resolver: { alphabet: string; unicodeVal: RegExp }) => {
          name = name.replace(resolver.unicodeVal, resolver.alphabet);
        }
      );
      values[index][key] = this.sanitize(name);
    });
    return values;
  }

  private static sanitize(value: string): string {
    let firstChar = null;
    value = value.replace(/ /g, '').replace(/<(.|\n)*?>/g, '');
    if (Number.isInteger(+value[0]) || this.specialCharCheck.test(value[0])) {
      firstChar = value[0];
    }
    value = value.replace(/[^a-zA-Z]/g, '');
    if (firstChar) {
      value = `${firstChar}${value}`;
    }
    return value;
  }
}
